<template>
  <SingleCourse />
</template>

<script>
import SingleCourse from '@/components/content/education/courses/EditCoursePage.vue'

export default {
  name: 'ContentCourse',
  components: { SingleCourse }
}
</script>

<style scoped>

</style>
